import React from 'react'
import styled from 'styled-components'
import {palette} from 'styled-tools'
import {media} from 'styled-bootstrap-grid'

import {Title5} from 'src/components/typography'
import type {Order} from 'src/api/saleor/generated'
import {CheckoutReceipt} from 'src/components/checkout'
import shadowStyles from 'src/styles/shadowStyles'

const Card = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  padding: 16px;
  flex-direction: column;
  align-items: stretch;
  background-color: ${palette('white')};
  z-index: -2;
  border: 1px solid ${palette('black10')};
  margin-bottom: 32px;

  ${media.md`
    padding: 48px;
    margin-bottom: 56px;
  `}
`
const CardHead = styled.div`
  width: 100%;
  padding: 18px;
  display: flex;
  align-items: center;
  border: 1px solid ${palette('primary')};
  margin-bottom: 50px;
  background-color: ${palette('white')};
  ${shadowStyles({
    color: 'red',
    outlined: false,
    length: 8,
    showOnHover: false,
  })}
  ${media.md`
    padding: 24px;
  `}
`

const Logo = styled.img`
  width: 42px;
  margin-right: 8px;
  margin-bottom: 8px;

  ${media.sm`
    width: 53px;
  `}
`

export default function CheckoutReceiptWrapper({
  order,
  method,
}: {
  order: Order
  method: string | undefined
}): JSX.Element {
  return (
    <Card>
      {!method && (
        <CardHead>
          <Logo src="/assets/rv-logo-solid.png" alt="logo" />
          <Title5>Takk fyrir að panta hjá Rekstrarvörum!</Title5>
        </CardHead>
      )}
      <CheckoutReceipt order={order} />
    </Card>
  )
}
